module.exports = __webpack_public_path__ + "img/bitu.441013f5.svg";